var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPianoKeys = function SvgIconPianoKeys(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 2.75A1.75 1.75 0 0 0 2.75 4.5v15c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75v-15a1.75 1.75 0 0 0-1.75-1.75zm.25 2v14.5h3.625V14.5H7.5a1 1 0 0 1-1-1V4.75zm3.75 0v7.75H11V4.75zm1.875 9.75v4.75h3.25V14.5zM13 4.75v7.75h2.5V4.75zm2.625 14.5V14.5h.875a1 1 0 0 0 1-1V4.75h1.75v14.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPianoKeys;